<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uid"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <a-switch
        slot="memberStatus"
        slot-scope="memberStatus"
        checked-children="正常"
        un-checked-children="关闭"
        :default-checked="memberStatus.usable === true ? true : false"
        @change="onChange"
      />
      <template slot="operate" slot-scope="text, operate">
        <a v-on:click.prevent="showModal(operate)">奖罚</a>
        <a-modal
          v-model="visible"
          title="奖罚"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <p>名称：{{ nickName }}</p>
          <p>
            奖罚：
            <a-radio-group
              name="radioGroup"
              @change="onChanges"
              :default-value="true"
              v-model="jsons.add"
            >
              <a-radio :value="true"> 奖励 </a-radio>
              <a-radio :value="false"> 罚款，扣款 </a-radio>
            </a-radio-group>
          </p>
          <p>
            金额：
            <a-input
              style="width: 150px"
              v-model="jsons.money"
              placeholder="金额不能为空"
            />
          </p>
          <p>
            奖罚原因：<a-textarea
              v-model="jsons.reason"
              placeholder="Basic usage"
              :rows="4"
            />
          </p>
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { userList, userPrizePenalty } from "@/api/userApi.js";
import { userDalanceSeach } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    align: "center",
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "用户uid",
    dataIndex: "uid",
    align: "center",
    scopedSlots: { customRender: "uid" },
  },
  {
    title: "手机号",
    align: "center",
    dataIndex: "phone",
  },
  {
    title: "昵称",
    dataIndex: "nickName",
    align: "center",
    scopedSlots: { customRender: "nickName" },
  },
  {
    title: "推荐码",
    dataIndex: "recommendCode",
    align: "center",
    scopedSlots: { customRender: "recommendCode" },
  },
  {
    title: "用户状态",
    dataIndex: "usable",
    align: "center",
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "用户余额",
    dataIndex: "balance",
    align: "center",
    scopedSlots: { customRender: "balance" },
  },
  {
    title: "所属地",
    dataIndex: "regionRecord",
    align: "center",
    scopedSlots: { customRender: "regionRecord" },
  },
  {
    title: "注册时间",
    dataIndex: "createTime",
    align: "center",
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    align: "center",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      jsons: {
        add: "",
        objId: "",
        reason: "",
        money: "",
        userType: "1101",
      },
      nickName: "",
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    // this.loading = true;
    this.getUserListData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      userList(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    getUserListData() {
      userList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.pagination.pageSize = 10;
        this.data = res.data;
        // this.loading = false;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    onChanges(e) {
      console.log(e.target.value);
    },
    query() {
      this.loading = true;
      userDalanceSeach(
        10,
        1,
        this.formInline.nickName,
        this.formInline.phone
      ).then((res) => {
        thgis.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    //
    showModal(row) {
      this.visible = true;
      console.log(row);
      this.nickName = row.nickName;
      this.jsons.objId = row.objId;
    },
    handleOk() {
      this.visible = false;
      userPrizePenalty(this.jsons).then((res) => {
        message.success(res.info);
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/financialManagement/userDalance/userDalanceContent.vue